// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"cf624e94","147":"2b6af492","295":"09e3e674","362":"94ad3b10","498":"c065a989","574":"b73a722e","807":"78082c55","818":"b5464638","899":"0576abcd","900":"7fa758ad","974":"94d6dcab","996":"32fcebbe"}[chunkId] + ".chunk.js";
};